// extracted by mini-css-extract-plugin
export default {"root":"FreightQuoteInfo_root__f2UUo","trigger":"FreightQuoteInfo_trigger__x2NTw","copy":"FreightQuoteInfo_copy__q7630"};